import { gql } from 'react-apollo';

export const getCurrentChurchGroups = gql`
   query getCurrentChurchGroups($churchId: Int!) {
    church: church_by_id(id: $churchId) {
      id
    	churchGroups: church_groups {
        edges {
          node {
            id
            name
            membersCount: members_count
          }
        }
      }
  	}
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/churchProfile/groups/queries/getCurrentChurchGroups.js